import '../App.css'
import darkmode0 from '../assets/darkmode/darkmode0.png'
import compatibility from '../assets/darkmode/compatibility.png'
import customize from '../assets/darkmode/customize.png'
import challenge from '../assets/darkmode/challenge.png'
import solution from '../assets/darkmode/solution.png'
import tokenmap from '../assets/darkmode/tokenmap.png'
import contrast from '../assets/darkmode/contrast.png'
import hierachy from '../assets/darkmode/hierachy.gif'
import color from '../assets/darkmode/color.png'
import contrast1 from '../assets/darkmode/contrast1.png'
import contrast2 from '../assets/darkmode/contrast2.png'
import hierachy1 from '../assets/darkmode/hierachy1.png'
import hierachy2 from '../assets/darkmode/hierachy2.png'
import tool from '../assets/darkmode/tool.mp4'


import Caption from '../components/ui/Caption'

const Darkmode = () => {
    return (
        <div className='project-container'>
            <div className='project-hero darkmode-bg'>
                <div className='h1 m-top-64 text-default-dm'>Bytedance Lark dark mode</div>
                <div className='p1 text-grey-dm m-top-16 con-960 text-center'>Dark mode color system for Lark suite, across desktop, mobile and pad.</div>
                <img src={darkmode0} style={{ width: '1200px' }} className='m-top-48 m-bottom-64'></img>
            </div>
            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>A snapshot</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'space-between' }}>
                    <div className='con-516'>
                        <Caption className='m-top-24'>My role</Caption>
                        <div className='h4 m-top-16'>Lead the design system of darkmode</div>
                        <div className='p2 text-grey m-top-8'>As the product design lead on darkmode design system, I came up with darkmode guideline & designed key screens</div>
                        <div className='h4 m-top-16'>Lead 10+ designers to collborate</div>
                        <div className='p2 text-grey m-top-8'>Orgnized 10+ designers over the orgnization to make all pillars of Lark suites adapt darkmode.</div>
                    </div>
                    <div className='con-516'>
                        <Caption className='m-top-24'>Product highlights</Caption>
                        <div className='h4 m-top-16'>25%+ mobile usage, 8%+ desktop usage</div>
                        <div className='p2 text-grey m-top-8'>Darkmode fullfilled user needs by making Lark suites to be compatible with the theme of operating system.</div>
                        <div className='h4 m-top-16'>Darkmode launched on Bytedance Lark conference</div>
                        <div className='p2 text-grey m-top-8'>As one of the core features, Darkmode was luanched in Nov 2021 on Bytedance Lark conference.</div>
                    </div>
                </div>
            </div>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>Why Darkmode</div>
            </div>
            <div className='con-1176 m-auto m-top-48 flex-between'>
                <div className='background-g1 con-576 darkmode-bg' style={{ paddingTop: '48px', overflow: 'hidden' }}>
                    <div className='h3 text-default-dm m-left-48'>Compatible with OS dark mode</div>
                    <div className='text-grey-dm p2 m-top-16 m-right-48 m-left-48'>Dark mode has becomes more and more of a fundamental user requirement, since more apps are adapting the dark mode to the operating system.</div>
                    <img src={compatibility} style={{ width: '576px' }}></img>
                </div>
                <div className='background-g1 con-576' style={{ paddingTop: '48px', overflow: 'hidden' }}>
                    <div className='h3 m-left-48 m-right-48'>Theme personalization</div>
                    <div className='text-grey p2 m-top-16 m-left-48 m-right-48'>While designing for dark mode, we had a chance to restructure the entire color scheme to make theme personalization easier for different company brands.</div>
                    <img src={customize} style={{ width: '576px' }}></img>
                </div>
            </div>
            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>System challenge</div>
                <div className='con-720 text-grey p2 m-top-24'>Before dark mode, we have one token for each system color. The challenge is that for different color themes, there are no corresponding relationships between color and interface components. So, designing for 2 themes would take almost as twice of the time on interface design, and that would not be manageable for such a big system.</div>
            </div>
            <img src={challenge} style={{ width: '1176px' }} className='m-auto m-top-24' loading='lazy'></img>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>Introduce alias token</div>
                <div className='con-720 text-grey p2 m-top-24'>To solve the system challenge, we introduced a new layer of alias token. We first map interface to alias tokens, and then map all the alias token to system tokens. In this way we only have to map the relationship once, and in the future we will only need to design for one theme, and other themes would be auto-generated based on alias tokens.</div>
            </div>
            <img src={solution} style={{ width: '1176px' }} className='m-auto m-top-24' loading='lazy'></img>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>Build token map</div>
                <div className='con-720 text-grey p2 m-top-24'>To start with, we took some key screens to design dark mode and start building off the foundational alias tokens, like background, text etc. And then organized designers on difference pillars of the app to go through all major screens and establish a complete token document.</div>
            </div>
            <div className='con-1176 background-g1 m-auto m-top-24' style={{ padding: '48px' }}>
                <img src={tokenmap} style={{ width: '1080px' }} className='s-1 r-8' loading='lazy'></img>
            </div>

            <div className='p2 text-grey m-top-144 m-bottom-16 m-auto con-1080' style={{ fontStyle: 'italic' }}>(The embeded Figma below may take a while to load)</div>

            <div className='darkmode-bg' style={{ width: '100%' }}>
                <div className='m-auto con-1280'>
                    <iframe width="1281" height="854" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FP0cNhtNEg2YzEYkLk0iInR%2FPrototypes%3Fpage-id%3D38%253A46%26node-id%3D419%253A20107%26viewport%3D245%252C48%252C0.11%26scaling%3Dscale-down-width%26starting-point-node-id%3D419%253A20107%26hide-ui%3D1" className='s-1 r-8' style={{ border: 'none' }}></iframe>
                </div>
            </div>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>Design techniques</div>
                <div className='p2 text-grey m-top-24 con-720'>Design techniques are ground rules we agreed upon, so that it guides the design of dark mode for all, especially when it comes to controversial decisions.</div>
            </div>

            <div className='con-1080 m-auto m-top-48 flex-between'>
                <div className='con-516'>
                    <div className='h3'>Contrast</div>
                    <div className='p2 text-grey m-top-16'>The color contrast technique obey 2 common rules. It emphasizes primary information and weakens secondary information. And there is really a gap, when testing the contrast for primary and secondary information, so that dark mode enables people to really focus on things that are important.</div>
                </div>
                <img className='con-540' src={contrast} loading='lazy'></img>
            </div>

            <div className='con-1080 m-auto m-top-144'>
                <div className='con-720'>
                    <div className='h3'>Vertical hierachy</div>
                    <div className='p2 text-grey m-top-24'>Unlike light mode which uses shadow to present vertical hierarchy, dark mode primarily uses luminance. Surface at a higher level are lighter, vice versa.</div>
                </div>
                <div className='con-1080 background-g1 m-top-16' style={{ padding: '48px 60px' }}>
                    <img src={hierachy} style={{ width: '960px' }} className='s-1' loading='lazy'></img>
                </div>
            </div>

            <div className='con-1080 m-auto m-top-144 flex-between'>
                <div className='con-516'>
                    <div className='h3'>Color</div>
                    <div className='p2 text-grey m-top-16'>We keep high saturation colors to brand colors, so to avoid vibrating color combination as much as possible. It helps the to user focus on actual content, especailly browsing through such an information condensed interface.</div>
                </div>
                <img className='con-540' src={color} loading='lazy'></img>
            </div>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>Design iterations</div>
                <div className='h3 m-top-24'>Improve contrast</div>
                <div className='p2 text-grey m-top-16 con-720'>We applied those design techniques to improve the color contrast, lightening the important information such as title, button text etc. and darkening the secondary visual elements such as borders, tags etc.</div>
            </div>
            <div className='con-1176 m-auto m-top-24 flex-between'>
                <img className='con-576' src={contrast1} loading='lazy'></img>
                <img className='con-576' src={contrast2} loading='lazy'></img>
            </div>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h3 m-top-24'>Elevation</div>
                <div className='p2 text-grey m-top-16 con-720'>We applied the techniques of adjusting brightness to reflect elevation, leveling different surface components so that they could be easily recognized by user.</div>
            </div>
            <div className='con-1176 m-auto m-top-24 flex-between'>
                <img className='con-576' src={hierachy1} loading='lazy'></img>
                <img className='con-576' src={hierachy2} loading='lazy'></img>
            </div>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>Data reference</div>
            </div>

            <div className='con-1176 m-top-48 m-auto flex-between'>
                <div className='data-card'>
                    <div style={{ display: 'flex' }}>
                        <div>
                            <Caption>Desktop</Caption>
                            <div className='m-top-24'><div className='data-number'>{">"} 9%</div>
                                {/* <div className='p2 text-grey'>Desktop app</div> */}
                            </div>
                        </div>
                        <div className='m-left-48'>
                            <Caption>Mobile</Caption>
                            <div className='m-top-24'><div className='data-number'>{">"} 25%</div>
                                {/* <div className='p2 text-grey'>Mobile app</div> */}
                            </div>
                        </div>
                    </div>
                    <div className='p2 m-top-16 text-grey'>The adoption rate is the North star number that we keep track of. Most of the users follow operating system settings for themes.</div>
                </div>
                <div className='data-card' style={{ marginTop: '240px' }}>
                    <Caption>Opt out</Caption>
                    <div className='m-top-24'><div className='data-number'>{"<"} 0.5%</div></div>
                    <div className='p2 m-top-16 text-grey'>There are only very few users who switched back to light mode manually, when they are introduced to dark theme by app.</div>
                </div>
            </div>

            <div className='con-1080 m-auto m-top-144'>
                <div className='h1'>Darkmode plugin</div>
                <div className='p2 text-grey m-top-16 con-720'>Dark mode Figma plugin helps designers to switch between dark mode and light mode in a snap. It greatly improves the effciency when designers are validating screens for different color themes.</div>
            </div>
            <div className='con-1080 m-top-24 m-auto' style={{ backgroundColor: '#e8e8e8', overflow: 'hidden', padding:'24px 0'}}>
                <div className='con-1080 m-auto m-top-24'>
                    <video width="1080" height="600" loop autoPlay muted>
                        <source src={tool} type="video/mp4" />
                    </video>
                </div>
            </div>

        </div>
    )
}

export default Darkmode